import type { ApplicationState } from '@/store';

export const selectSidenavCollapsed = (state: ApplicationState) =>
  state.interface.sidenavCollapsed;

export const selectFullscreenMode = (state: ApplicationState) =>
  state.interface.fullscreenMode;
